<template>
  <div class='w100pct logoclass'>
    <!-- <transition name="fade"> -->
      <img :src="srcimg" :class='customClass' class="face posA" v-show="!showSvg" />
    <!-- </transition> -->
    <!-- <transition name="fade"> -->
      <Icon name="incFace" v-if='LogoType==="merchants"' :class='customClass' class="posA" sizeBase='xs' v-show="showSvg"></Icon>
      <Icon name="userFace" v-else :class='customClass' class="posA " sizeBase='xs' v-show="showSvg"></Icon>
    <!-- </transition> -->
  </div>
</template>
<script>
export default {
  name: 'logoImg',
  props: {
    customClass: {
      type: String,
      default: ''
    },
    LogoType: {
      type: String,
      default: 'merchants' // person为用户头像
    },
    Logourl: {
      type: String,
      default: ''
    }
  },
  watch: {
    Logourl (v) {
      this.validateImage(v)
    }
  },
  data () {
    return {
      showSvg: true,
      srcimg: null

    }
  },
  methods: {
    validateImage (pathImg) {
      this.showSvg = true
      this.srcimg = ''
      var ImgObj = new Image()
      let that = this
      if (pathImg) {
        ImgObj.onload = function () {
          
          if (ImgObj.fileSize > 0 || (ImgObj.width > 0 && ImgObj.height > 0)) {
            that.srcimg = ImgObj.src
            that.showSvg = false
            return true
          } else {
            that.srcimg = ''
            that.showSvg = true
            return false
          }
        }
        ImgObj.src = pathImg
      } else {
        that.showSvg = true
        this.srcimg = ''
      }
    }
  },
  mounted () {
    this.validateImage(this.Logourl)
  }

}
</script>
<style lang="scss" scoped>
.logoclass {
  display: flex;
  justify-content: center;
  position: relative;
  img {
    width: 100%;
  }
}
.face {
}
// .fade-enter-active,
// .fade-leave-active {
//   transition: opacity 0s;
// }
// .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
//   opacity: 0;
// }
</style>



// WEBPACK FOOTER //
// src/components/common/ui/Logo.vue